module.exports = __webpack_public_path__ + "static/media/Ex2-S7.d5b507d0.PNG";